import { Controller, useFormContext } from "react-hook-form";

import FormToggleField from "ds/components/Form/ToggleField";

const AttachCloudFormReadToggleField = () => {
  const { control } = useFormContext<{ read: boolean; write: boolean }>();
  return (
    <Controller
      name="read"
      control={control}
      rules={{
        validate: (value, values) =>
          value === false && values.write === false
            ? "At least one permission must be selected"
            : undefined,
      }}
      render={({ field }) => (
        <FormToggleField
          variant="switch"
          onChange={field.onChange}
          checked={field.value}
          title="Read"
          description="Integration will be used during read phases of runs (for example, plans)."
        />
      )}
    />
  );
};

export default AttachCloudFormReadToggleField;
